import { useState } from "react";
import type { FaqItem } from "@/mocks/faq";

interface FaqSectionProps {
  faqs: FaqItem[];
  heading?: string;
  intro?: string;
}

export default function FaqSection({ faqs, heading, intro }: FaqSectionProps) {
  const [openId, setOpenId] = useState<string | null>(faqs[0]?.id ?? null);

  return (
    <section className="py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-8">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-14">
          <div className="lg:col-span-4">
            <span className="text-xs font-medium tracking-[0.3em] text-primary-600">
              FAQ
            </span>
            <h2 className="mt-4 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
              {heading ?? "关于看料档案，你可能想问"}
            </h2>
            <p className="mt-5 text-sm leading-7 text-foreground-600">
              {intro ??
                "我们整理了读者最常提出的问题。如果没有找到答案，欢迎通过订阅表单留下你的疑问。"}
            </p>
          </div>

          <div className="lg:col-span-8">
            <div className="divide-y divide-background-200 border-y border-background-200">
              {faqs.map((item) => {
                const isOpen = openId === item.id;
                return (
                  <div key={item.id}>
                    <button
                      type="button"
                      onClick={() => setOpenId(isOpen ? null : item.id)}
                      className="flex w-full items-center justify-between gap-4 py-5 text-left"
                      aria-expanded={isOpen}
                    >
                      <h3 className="font-heading text-base font-semibold text-foreground-950 md:text-lg">
                        {item.question}
                      </h3>
                      <span
                        className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${
                          isOpen
                            ? "bg-primary-500 text-background-50"
                            : "bg-background-100 text-foreground-600"
                        }`}
                      >
                        <i className={isOpen ? "ri-subtract-line" : "ri-add-line"} />
                      </span>
                    </button>
                    {isOpen && (
                      <p className="pb-6 pr-10 text-sm leading-7 text-foreground-600">
                        {item.answer}
                      </p>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}